import { useMemo } from "react";
import {
  Autocomplete,
  Box,
  TextField,
  Typography,
  createFilterOptions,
  useTheme,
} from "@mui/material";
import styles from "./styles";

// Busca por substring no texto de exibição do host (mesmo campo mostrado na lista)
const filtroHost = createFilterOptions({
  stringify: (opcao) => (typeof opcao === "string" ? opcao : opcao?.host || ""),
});

// Combobox freeSolo que grava direto em data.nome do node: o usuário escolhe um
// host do cliente (já filtrado pelo serviço do circuito, agrupado pela função
// configurada no host — CPE, OLT, Switch etc.) ou digita um nome livre
export default function HostAutocomplete({
  value = "",
  onChange = () => {},
  hostOptions = [],
  disabled = false,
}) {
  const theme = useTheme();
  const hostStyles = styles(theme);

  // groupBy exige que as opções do mesmo grupo venham contíguas
  const options = useMemo(
    () =>
      [...(hostOptions || [])].sort((a, b) =>
        (a?.funcao || "").localeCompare(b?.funcao || ""),
      ),
    [hostOptions],
  );

  return (
    <Autocomplete
      size="small"
      fullWidth
      freeSolo
      disabled={disabled}
      options={options}
      value={value}
      inputValue={value}
      groupBy={(opcao) => opcao?.funcao?.trim?.() || "Outros"}
      getOptionLabel={(opcao) => (typeof opcao === "string" ? opcao : opcao?.host || "")}
      filterOptions={filtroHost}
      onChange={(_evento, novoValor) =>
        onChange(typeof novoValor === "string" ? novoValor : novoValor?.host || "")
      }
      onInputChange={(_evento, novoTexto) => onChange(novoTexto || "")}
      ListboxProps={{ sx: hostStyles.listbox }}
      renderOption={(props, opcao) => (
        <Box component="li" {...props} key={opcao?.id || opcao?.host}>
          <Typography noWrap sx={hostStyles.optionLabel}>
            {opcao?.host}
          </Typography>
        </Box>
      )}
      renderInput={(params) => (
        <TextField {...params} label="Nome" autoComplete="off" />
      )}
      noOptionsText="Nenhum host encontrado para este serviço"
    />
  );
}
